export default "__VITE_ASSET__R6yR2pGT__"